export default {
    labels: {
         cancel: "Cancelar",
        current: "etapa atual:",
        pagination: "Paginação",
        finish: "Cadastrar",
        next: "Próximo",
        previous: "Anterior",
        loading: "Carregando ...",
    },
}
